import {Component, OnInit, ViewChild} from '@angular/core';
import {RedirectLogService} from '../../services/redirect-log.service';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AuxiliarService} from '../../../../../shared/services/auxiliar.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import {Angular2Csv} from 'angular2-csv';
import * as _ from 'underscore';
import * as moment from 'moment';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';

@Component({
  selector: 'app-redirect-log',
  templateUrl: './redirect-log.component.html',
  styleUrls: ['./redirect-log.component.scss']
})
export class RedirectLogComponent extends ModalExtended implements OnInit {

    data: Object;
    loading: boolean = false;
    logs: Array<Object> = [];
    form: FormGroup;

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 6;

    @ViewChild (PaginationComponent) pagination: PaginationComponent;

    constructor(private redirectLogService: RedirectLogService, private fb: FormBuilder, private aux: AuxiliarService, private datesParser: DatesParserService) {
        super();

        this.form = this.fb.group({
            'start_date' : new FormControl(),
            'end_date' : new FormControl(),
            'service_campaign_action_pk' : new FormControl()
        });
    }

    ngOnInit() {
        this.loading = true;
        this
            .redirectLogService
            .findRedirectLogs({'service_campaign_pk' : this.data['camp_pk']})
            .subscribe(
                (r) => {
                    this.logs = r;
                    this.endAt = (!this.haveToPaginate()) ? this.logs.length : this.perPage;
                    this.loading = false;
                }
            )
    }

    toCsv(): void {

        const headers = _.keys(this.logs[0]);
        new Angular2Csv(this.logs, 'redirect_logs_' + this.data['camp_name'] + '_' + moment().unix(), {
            'showLabels' : true,
            'headers': headers
        });
    }

    goToPage(n: number) {
        this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
    }

    copy(url){
        this.aux.copyToClip(url);
    }

    haveToPaginate(): boolean {
        return this.perPage < this.logs.length;
    }

    findRedirectLogs(): void {
        this.loading = true;

        const query = this.datesParser.cleanDates(this.form.value, ['start_date', 'end_date'], false);
        query['service_campaign_pk'] = this.data['camp_pk'];
        this.redirectLogService.findRedirectLogs(query).subscribe(
            (r) => {
                this.logs = r;
                this.endAt = (!this.haveToPaginate()) ? this.logs.length : this.perPage;
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/redirect-log/redirect-log.component.ts